import { FormattedMessage } from 'react-intl';
import TopUpStatusMessage from './TopUpStatusMessage';
import messages from './TopUpStatusMessages.messages';

export const TopUpDeclined = () => {
    return (
        <TopUpStatusMessage
            heading={<FormattedMessage {...messages.topupDeclined} />}
        />
    );
};
